<template>
  <div class="base-checkbox">
    <input class="base-checkbox__input"
           :checked="value"
           type="checkbox"
           @change="$emit('input', $event.target.checked)"
    />
    <div v-if="label" @click="$emit('click-label')" v-html="label" class="base-checkbox__label"></div>
  </div>
</template>

<script>
export default {
  name: "BaseCheckbox",
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .base-checkbox {
    display: flex;
    align-items: center;

    &__input {
      height: 1.5rem;
      width: 1.5rem;
      background: #F4F7F8;
      margin: 0 0.5rem 0 0;
    }

    &__label {
      cursor: pointer;
    }

  }
</style>